import { gql } from '@apollo/client'

export const GET_AD_CREATIVES_WITH_FILTERS = gql`
    query GetAdCreativesWithFilters($searchTerm: String, $formats: [AdCreativeFormat!], $campaignId: String) {
        AdCreative {
            searchAdCreativesWithFilters(searchTerm: $searchTerm, formats: $formats, campaignId: $campaignId) {
                id
                name
                format
                status
                is_used
                tags
                primary_texts
                headlines
                descriptions
                call_to_action_type
                call_to_action_url
                call_to_action_text
                facebook_page_id
                instagram_page_id
                created_at
                updated_at
            }
        }
    }
`

export const GET_AD_CREATIVES_WITH_ASSETS = gql`
    query GetAdCreativesWithAssets($searchTerm: String, $formats: [AdCreativeFormat!], $campaignId: String) {
        AdCreative {
            searchFilterAdCreativesJoinAssets(searchTerm: $searchTerm, formats: $formats, campaignId: $campaignId) {
                id
                name
                format
                status
                is_used
                tags
                primary_texts
                headlines
                descriptions
                call_to_action_type
                call_to_action_url
                call_to_action_text
                facebook_page_id
                instagram_page_id
                created_at
                updated_at
                lead_form_id
                error
                adAssets {
                    id
                    name
                    url
                    mime_type
                    size
                    width
                    height
                    type
                    source
                    source_id
                    variations {
                        id
                        ad_creative_asset_id
                        adCreativeAsset {
                            id
                            name
                            url
                            height
                            width
                            mime_type
                            size
                            type
                            thumbnails {
                                height
                                width
                                url
                            }
                        }
                        format
                        cropped
                        crop_data
                        created_at
                        updated_at
                    }
                    trim_data {
                        start
                        end
                    }
                    thumbnails {
                        height
                        width
                        url
                    }
                    headline
                    description
                    image_alt_text
                    position
                    duration
                    status
                    created_at
                    updated_at
                }
            }
        }
    }
`

export const DELETE_AD_CREATIVE = gql`
    mutation DeleteAdCreative($id: ID!, $publisherId: String!, $campaignId: String!) {
        deleteAdCreative(id: $id, publisherId: $publisherId, campaignId: $campaignId)
    }
`

export const UPDATE_AD_CREATIVE_USED_STATUS = gql`
    mutation UpdateAdCreative($id: ID!, $input: UpdateAdCreativeInput!) {
        updateAdCreative(id: $id, input: $input) {
            id
            is_used
        }
    }
`

export const UPDATE_AD_CREATIVE_FULL = gql`
    mutation UpdateAdCreativeFull($id: ID!, $input: UpdateAdCreativeInput!, $campaignId: ID) {
        updateAdCreative(id: $id, input: $input, campaignId: $campaignId) {
            id
            name
            format
            status
            tags
            primary_texts
            headlines
            descriptions
            call_to_action_type
            call_to_action_url
            call_to_action_text
            lead_form_id
            updated_at
        }
    }
`

export const AD_CREATIVE_STATUS_UPDATE = gql`
    subscription AdCreativeStatusUpdate($userId: ID!) {
        adCreativeStatusUpdate(userId: $userId) {
            id
            status
            name
            external_ids
            published_at
            updated_at
            error
        }
    }
`
export const CLEAN_UP_AD_CREATIVE_ASSETS = gql`
    mutation CleanUpAdCreativeAssets($adCreativeId: ID!) {
        cleanUpAdAssets(adCreativeId: $adCreativeId)
    }
`
